const userHasRecordingPermission = (
  user: { roles: Record<string, string> } | undefined,
  organizationId: string | number
): boolean => {
  const userRoles = user?.roles[organizationId];
  return userRoles !== undefined && userRoles !== 'presenter';
};

const userCanRecordWebsite = (
  url: string,
  organization: { allowed_hosts: string[] }
): boolean => {
  return (
    !url.length ||
    !!organization.allowed_hosts.find(
      (host: string) =>
        host === '*' || host === url || `https://${host}` === url
    )
  );
};

const isURLAllowedByOrg = (
  url: string,
  org: { allowed_hosts: string[] }
): boolean => {
  if (org.allowed_hosts.includes('*')) return true;

  const hostName = new URL(url).hostname;
  const domain = hostName.replace('www.', '');

  return org.allowed_hosts.includes(domain);
};

const getHostname = (url: string) => {
  return new URL(url).hostname;
};

export {
  userHasRecordingPermission,
  userCanRecordWebsite,
  getHostname,
  isURLAllowedByOrg,
};
